import styled, { css } from "styled-components";
import {
  borderRadius,
  borderWidth,
  borderStyle,
} from "../../../design-system/tokens/borders";
import { spacing } from "../../../design-system/tokens/spacing";
import { rawColors } from "../../../design-system/tokens/colors";
import { KG_SQUARE_NODE_SIZE_PX } from "../../kg/kgNodeDimensions";
import {
  kgCategorySelectionShadow,
  kgLineageCategoryBorderColors,
} from "../../kg/kgLineageTokens";
import type { KgLineageCategory } from "../../kg/kgLineageTokens";
import type { KgNodeVisualState } from "../../kg/kgNodeShared.types";

const squareNodeFrameStyles = css`
  width: ${KG_SQUARE_NODE_SIZE_PX}px;
  height: ${KG_SQUARE_NODE_SIZE_PX}px;
  min-width: ${KG_SQUARE_NODE_SIZE_PX}px;
  max-width: ${KG_SQUARE_NODE_SIZE_PX}px;
  flex-shrink: 0;
`;

const resolveBorderColor = (category: KgLineageCategory) =>
  kgLineageCategoryBorderColors[category];

export const Outer = styled.div<{
  $category: KgLineageCategory;
  $visualState: KgNodeVisualState;
  $isSelected: boolean;
  $clickable?: boolean;
}>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
  border-radius: ${borderRadius.lg};
  border-width: ${borderWidth[1]};
  border-style: ${({ $visualState }) =>
    $visualState === "draft" ? borderStyle.dashed : borderStyle.solid};
  border-color: ${({ $category }) => resolveBorderColor($category)};
  background: ${rawColors.structural.white};
  box-shadow: ${({ $category, $isSelected }) =>
    kgCategorySelectionShadow($category, $isSelected)};
  outline: none;
  transition: box-shadow 0.25s ease;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};

  ${({ $category }) =>
    ($category === "dataSource" || $category === "schema") &&
    css`
      ${squareNodeFrameStyles}
      border-radius: ${borderRadius["2xl"]};
    `}

  ${({ $category }) =>
    $category === "table" &&
    css`
      width: 100%;
      border-radius: ${borderRadius["2xl"]};
      overflow: hidden;
    `}
`;

export const Inner = styled.div<{
  $flush: boolean;
  $category: KgLineageCategory;
}>`
  padding: ${({ $flush }) => ($flush ? "0" : spacing[3])};
  box-sizing: border-box;

  ${({ $category }) =>
    ($category === "dataSource" || $category === "schema") &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      min-height: 0;
      overflow: hidden;
    `}
`;
